import React, {Component} from 'react';
import {Field, reduxForm} from 'redux-form'
import fetch from 'isomorphic-fetch'
import FileUtils from '../utils/FileUtils'
import {parseString} from "xml2js";
import { connect } from 'react-redux'
import { formValueSelector } from 'redux-form'
import actions from '../actionCreators'
import ISpan from "../i18n/ISpan";
import defaults from "../utils/defaullts";

export class RemoteDropdown extends Component {
    constructor(props){
        super(props);
        let me = this;
        me.state = {options: []};
        fetch(this.props.endPoint).then(response => response.text()).then(text => {
            let options = [];
            parseString(text, function (err, result) {
                if(result && result.options)
                    me.setState({options: result.options.option});
            });
        });
    }

    render(){
        let options = this.state.options;
        return <Field name={this.props.name} component="select">
            {
                options.map((archive) => {
                    let name = archive._;
                    let value = archive.$.value;
                    return <option key={value} value={value}>{name}</option>
                })
            }
        </Field>
    }
}

export let FormContainer = (props) => {
    return <div data-bind="with:searchForm" className={"five columns"}>
        <div>
            {props.children}
        </div>
    </div>
};

export let resultsPerPage = () =>{
    return <Field name="count" component="select">
        <option value={5}>5</option>
        <option value={10}>10</option>
        <option value={20}>20</option>
    </Field>
};

export class SearchForm extends Component {
}

class PrimarySearchForm extends SearchForm {
    render() {
        const {
            handleSubmit, pristine, reset, submitting
        } = this.props;

        let result_type = this.props.result_type;
        let isContentOnly = result_type === "show_content_only";

        return <FormContainer>
            <div>
                <form data-bind="submit:performSearch" onSubmit={handleSubmit}>
                    <Field name="result_type" component="select">
                        <option value={'show_all'}>All</option>
                        <option value={'show_content_only'}>Content</option>
                        <option value={'show_images'}>Images</option>
                        <option value={'show_documents'}>Documents</option>
                    </Field>

                    {/*<input type="checkbox" data-bind="checked:showImages"></input>*/}
                    {/*<Field name="showImages" id="showImages" component="input" type="checkbox"/>*/}
                    {/*<span <ISpan localisationId="" defaultValue=""/>"common.labels.types.images">Images</span>*/}
                    {/*<input type="checkbox" data-bind="checked:showDocuments"/>*/}
                    {/*<Field name="showDocuments" id="showDocuments" component="input" type="checkbox"/>*/}
                    {/*<span <ISpan localisationId="" defaultValue=""/>"common.labels.types.documents"> Documents </span><br/>*/}
                    {/*<br/>*/}
                    {/*<input type="checkbox" data-bind="checked:isContentOnly"/>*/}
                    {/*<Field name="isContentOnly" id="isContentOnly" component="input" type="checkbox"/>*/}

                    {/*<span*/}
                    {/*<ISpan localisationId="" defaultValue=""/>"common.labels.types.content_only">Content Only</span><br/><br/>*/}
                    <label htmlFor="textText"><ISpan localisationId="common.labels.text" defaultValue="Text"/></label>
                    <Field name="text" id="textText" component="input" type="text" />

                    {/*<input data-bind="value:text" type="text" name="" id="textText"/>*/}
                    <label> <ISpan localisationId="common.labels.archive" defaultValue="Archive"/></label>
                    {/*<select data-bind="value: archiveRef, options:archives, optionsText: 'optionName', optionsValue: 'optionValue', event: {change: performSearch}"></select>*/}

                    <RemoteDropdown name="archive" endPoint={FileUtils.getArchivesUrl()}/>


                    <label><ISpan localisationId="common.labels.outline" defaultValue="Outline"/></label>
                    {/*<select data-bind="value: outline, options:outlines, optionsText: 'optionName', optionsValue: 'optionValue', event: {change: performSearch}"></select>*/}
                    <RemoteDropdown name="outline" endPoint={FileUtils.getOutlinesUrl()}/>

                    <div>
                        <label> <ISpan localisationId="common.labels.time_period" defaultValue="Time Period"/></label>
                        <div className={"row"}>
                            <span><ISpan localisationId="common.labels.from_year" defaultValue="From :"/></span>{' '}
                            <Field name="startDate" component="input" type="number" min={0} step={1} size={4} className="year-field"/>
                            {/*<input type="number" min="0" size="4" name="" className={"year-field"} data-bind="value:startDate"></input>*/}
                            {' '}<span><ISpan localisationId="common.labels.to_year" defaultValue="To :"/></span>{' '}
                            <Field name="endDate" component="input" type="number" min={0} step={1} size={4} className="year-field"/>
                            {/*<input type="number" min="0" size="4" name="" className={"year-field"} data-bind="value:endDate"></input>*/}
                        </div>
                    </div>
                    <label> <ISpan localisationId="common.labels.results_per_page" defaultValue="Results Per Page"/></label>
                    {/*<select data-bind="value: resultsPerPage, options:paginationOptions, optionsText: 'optionName', optionsValue: 'optionValue', event: {change: performSearch}"></select>*/}
                    {resultsPerPage()}
                    {/*Search Button*/}
                    <button type="submit" data-bind="click: performSearch"> <ISpan localisationId="common.buttons.search" defaultValue="Search"/></button>{' '}

                    {/*Clear Button*/}
                    <button data-bind="click: clearSearch" disabled={pristine || submitting} onClick={() => {
                        reset();
                        this.props.clearSearchValues();
                    }}><ISpan localisationId="common.buttons.clear" defaultValue="Clear"/></button>


                </form>

            </div>

            {isContentOnly}

            {isContentOnly && <div data-bind="visible:isContentOnly() == true, localize: isContentOnly()">
                <div className={"back-message"}>
                    <ISpan localisationId="common.messages.showing_content_only.message" defaultValue="Note: Showing contents only. Uncheck the Content Only to view containers"/>
                    <br/>
                </div>
            </div>}
        </FormContainer>
    }
}


PrimarySearchForm = reduxForm({
    form: 'primarySearchForm' // a unique identifier for this form
})(PrimarySearchForm);

export let clearSearchValues = () => {
    return (dispatch) => {
        dispatch(actions.clearPrimarySearch())
    }
};

const selector = formValueSelector('primarySearchForm'); // <-- same as form name
PrimarySearchForm = connect(
    (state, ownProps) => {
        // can select values individually
        const result_type = selector(state, 'result_type');

        let archive = state.searchResults.searchValues ? state.searchResults.searchValues.archive : undefined;
        let initialValues = {
            searchType: 'primary',
            result_type: state.searchResults.searchValues ? state.searchResults.searchValues.result_type : "show_all",
            count: defaults.search.count
        };
        if(archive){
            initialValues.archive = archive;
        }

        return {
            initialValues: initialValues,
            result_type
        }
    },
    (dispatch) => {
        return {
            clearSearchValues: () => dispatch(clearSearchValues())
        }
    }
)(PrimarySearchForm);

export default PrimarySearchForm;



// WEBPACK FOOTER //
// ./src/components/SearchForm.js